module.exports = __webpack_public_path__ + "61ea17f16c.woff2";